import { createTheme, Theme } from '@mui/material/styles'

// Light theme
export const lightTheme: Theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#D70000',
      dark: '#A30000',
      light: '#FFE2E2',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FAFAFA',
    },
    text: {
      primary: '#141414',
      secondary: '#767676',
      disabled: '#A0A0A0',
    },
    divider: '#E0E0E0',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#E0E0E0',
            },
            '&:hover fieldset': {
              borderColor: '#C0C0C0',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#D70000',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#767676',
          },
          '& .MuiInputBase-input': {
            color: '#141414',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '& .MuiBox-root': {
            backgroundColor: '#FFFFFF',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#D70000',
        },
      },
    },
  },
})

// Dark theme
export const darkTheme: Theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF4444',
      dark: '#FF6666',
      light: '#3D1A1A',
    },
    background: {
      default: '#1A1A1A',
      paper: '#252525',
    },
    text: {
      primary: '#E8E8E8',
      secondary: '#A0A0A0',
      disabled: '#666666',
    },
    divider: '#404040',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#252525',
            '& fieldset': {
              borderColor: '#404040',
            },
            '&:hover fieldset': {
              borderColor: '#555555',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FF4444',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#A0A0A0',
          },
          '& .MuiInputBase-input': {
            color: '#E8E8E8',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#252525',
          color: '#E8E8E8',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: '#252525',
          color: '#E8E8E8',
          '&:hover': {
            backgroundColor: '#2D2D2D',
          },
          '&.Mui-selected': {
            backgroundColor: '#3D1A1A',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '& .MuiBox-root': {
            backgroundColor: '#1A1A1A',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#FF4444',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#252525',
        },
      },
    },
  },
})
